import { cn } from "@/lib/utils";

const variants = {
  primary:
    "bg-gradient-to-r from-violet-600 to-cyan-500 text-white hover:opacity-90 hover:scale-[1.02] active:scale-[0.98] shadow-lg shadow-violet-500/20",
  secondary:
    "bg-zinc-200 border border-zinc-300 text-zinc-800 hover:bg-zinc-300 dark:bg-white/5 dark:border-white/10 dark:text-zinc-200 dark:hover:bg-white/10",
  ghost:
    "text-zinc-600 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-zinc-100 transition-colors",
  outline:
    "border border-violet-500/50 text-violet-400 hover:bg-violet-500/10 transition-colors",
};

const sizes = {
  sm: "px-4 py-2 text-sm",
  md: "px-5 py-2.5 text-sm",
  lg: "px-6 py-3 text-base",
};

export default function Button({
  variant = "primary",
  size = "md",
  className,
  children,
  ...props
}) {
  return (
    <button
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-xl font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-zinc-950 disabled:opacity-50 disabled:pointer-events-none",
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
